import React from "react";
import styles from "./Statistics.module.css";

export const Statistics = () => {
  return (
    <div className={styles.container}>
      <div className={styles.cardContainer}>
        <div className={styles.card}>
          <h2 className={styles.secondaryTitle}>Americans lost</h2>
          <h1 className={styles.title}>$12.5 billion</h1>
          <h2 className={styles.secondaryTitle}>to online fraud in 2023</h2>
        </div>
        <div className={`${styles.card} ${styles.card1}`}>
          <h2 className={styles.secondaryTitle}>Of which</h2>
          <h1 className={styles.title}>$330 million</h1>
          <h2 className={styles.secondaryTitle}>
            was through text message scams
          </h2>
        </div>
        <div className={`${styles.card} ${styles.card2}`}>
          <h2 className={styles.secondaryTitle}>
            Half of call center scam victims were over
          </h2>
          <h1 className={styles.title}>60 years old</h1>
          <h2 className={styles.secondaryTitle}>
            accounting for $724 million in losses
          </h2>
        </div>
      </div>
    </div>
  );
};
